'use strict';

import { CoreRepository } from '../CoreRepository';
import { UserCallLog } from '../../Entities/User/UserCallLog';
import { UserCallLogCollection } from '../../Collections/User/UserCallLogCollection';

export class UserCallLogRepository extends CoreRepository {
  public getUserIndCallLogs(
    userId: number,
    indId: number,
    options: object = {},
    criteria: object = null
  ) {
    if (!options) {
      options = {};
    }

    if (criteria) {
      options['criteria'] = criteria;
    }

    return this.webAPI.getUserIndCallLogs(userId, indId, options).then((response) => {
      const collection = new UserCallLogCollection();

      response.data.forEach((collectionItemData) => {
        const collectionItem = new UserCallLog();
        collectionItem.hydrate(collectionItemData);

        collection.addItem(collectionItem);
      });

      collection.setOffset(response.offset);
      collection.setLimit(response.limit);
      collection.setTotal(response.total);

      return collection;
    });
  }

  public updateUserIndCallLog(userId: number, id: number, payload: any[]) {
    return this.webAPI.updateUserIndCallLog(userId, id, payload).then((response) => {
      return response;
    });
  }

  public getUserCallLogs(userId: number, options: object = {}, criteria: object = null) {
    if (!options) {
      options = {};
    }

    if (criteria) {
      options['criteria'] = criteria;
    }

    return this.webAPI.getUserCallLogs(userId, options).then((response) => {
      const collection = new UserCallLogCollection();

      response.data.forEach((collectionItemData) => {
        const collectionItem = new UserCallLog();
        collectionItem.hydrate(collectionItemData);

        collection.addItem(collectionItem);
      });

      collection.setOffset(response.offset);
      collection.setLimit(response.limit);
      collection.setTotal(response.total);

      return collection;
    });
  }

  public moveUserIndCallLogs(userId: number, individualId: number, payload: any[]) {
    return this.webAPI.moveUserIndCallLogs(userId, individualId, payload).then((response) => {
      return response;
    });
  }
}
